import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.spadmin', {
        redirectTo: 'company.spadmin.companies',
        url: '/spadmin',
        component: 'companySPAdmin',
        resolve: {},
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sp-admin/sp-admin.state.js